import { Button } from "@/components/ui/button";
import { Form, FormControl, FormItem } from "@/components/ui/form";
import { FormField } from "@/components/ui/form/FormField";
import { Textarea } from "@/components/ui/textarea";
import type { FeedbackFormSchemaType } from "@/schemas/feedback.schema";
import { useNavigate } from "@tanstack/react-router";
import { MessageCircleMore } from "lucide-react";
import type { FunctionComponent } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

export const FeedbackPage: FunctionComponent = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const form = useForm<FeedbackFormSchemaType>({
    defaultValues: {
      feedback: "",
    },
  });

  const {
    formState: { isValid },
  } = form;

  const handleGoBack = async (): Promise<void> => {
    await navigate({ to: "/visits" });
  };

  const handleSendFeedback = async (): Promise<void> => {};

  return (
    <div className="flex items-between flex-col size-full w-screen h-screen">
      <div className="flex justify-center border-b-[1px] border-[#EEEEEE] border-solid p-4 bg-primary md:bg-white">
        <h4 className="m-0 text-xl font-bold md:text-primary text-white">
          ROSC
        </h4>
      </div>

      <div className="flex flex-col justify-center items-center size-full">
        <div className="text-center md:w-[70%] lg:w-[50%] w-[90%]">
          <Form {...form}>
            <div className="flex justify-center mb-4">
              <MessageCircleMore color="#6F7293" />
            </div>

            <h6>{t("feedback.title")}</h6>

            <p className="text-tinted-grey-3 mt-2">
              {t("feedback.description")}
            </p>

            <FormField
              control={form.control}
              name="feedback"
              render={({ field }) => (
                <FormItem>
                  <FormControl>
                    <Textarea
                      className="mt-4"
                      placeholder={t("feedback.textAreaPlaceholder")}
                      {...field}
                    />
                  </FormControl>
                </FormItem>
              )}
            />

            <div className="flex justify-center">
              <div className="flex gap-4">
                <Button
                  className="mt-6"
                  size="lg"
                  type="submit"
                  onClick={handleGoBack}
                >
                  {t("feedback.backBtn")}
                </Button>

                <Button
                  className="mt-6"
                  disabled={!isValid}
                  size="lg"
                  type="submit"
                  onClick={handleSendFeedback}
                >
                  {t("feedback.sendBtn")}
                </Button>
              </div>
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
};
